import { useCallback, useMemo, useRef, useState } from "react";
import { Alert, Form } from "react-bootstrap";
import { useStore } from "react-redux";
import xss from "xss";

const InputKennziffer = (props) => {
  const { currenciesStorage, metalsStorage } = useStore().getState();
  const { className, name, value, checked, onBlur, onChange, onFocus, meta, field, ...attributes } = props || {};
  const { label, ariaLabel, placeholder } = field || {};
  const [error, setError] = useState("");

  let selected = useRef("");
  const liste = useMemo(() => {
    const liste = {};
    selected.current = "";
    currenciesStorage.getItems().forEach(i => {
      if (i.kennziffer === value) selected.current = "(" + i.name + ")";
      liste[String(i.kennziffer)] = i.name + "(" + i.iso + ")";
    });
    metalsStorage.getItems().forEach(i => {
      if (i.kennziffer === value) selected.current = "(" + i.name + ")";
      liste[String(i.kennziffer)] = i.name;
    });
    return liste;
  }, [currenciesStorage, metalsStorage, value]);

  const options = Object.keys(liste).map(key => <option key={key} value={key}>{liste[key]} ({key})</option>);

  const onSelectOrChange = useCallback((e) => {
    const target = e && (e.currentTarget || e.target);
    // Issue#151 beim Select aus der Liste die Liste ausblenden
    if (target && e.nativeEvent &&
      (
        e.nativeEvent.inputType === "insertReplacementText" || //Firefox
        ( // Edge/Chrome
          e.nativeEvent.type === "input" &&
          !e.nativeEvent.inputType
        )
      )
    ) {
      target.blur();
      setTimeout(() => target.focus(), 50);
    }
    if (typeof onChange === "function") onChange(e);
  }, [onChange]);

  const onChangeSearch = useCallback((e) => {
    const target = e && (e.currentTarget || e.target);
    setError("");
    if (target && target.value > "" && typeof onBlur === "function") {
      const search = xss(target.value).replace(/[><*?"']/, "");
      if (!isNaN(search) && typeof onBlur === "function") return onBlur(e);
      const match = Object.keys(liste).find(i => liste[i].match(new RegExp(search, "i")));
      if (match) {
        target.value = match;
      } else {
        setError("Bei aktuell nicht handelbaren Produkten kann nur über die Eingabe der Kennziffer gesucht werden.");
        target.value = "";
      }
      if (typeof onChange === "function") onChange(e);
    }
  }, [liste, onBlur, onChange]);

  const onKeyPress = useCallback((e) => {
    if (!e || e.key !== "Enter") return;
    // do not send Form on RETURN
    e.preventDefault();
    e.currentTarget.blur();
    return false;
  }, []);

  return <div className={"row " + className}>
    <Form.Label htmlFor={name} className="col-6 col-form-label col-form-label-sm" >{label} {selected.current}</Form.Label>
    <div className="col-6">
      <Form.Control
        {...attributes}
        id={name}
        name={name}
        value={value}
        onChange={onSelectOrChange}
        onFocus={onFocus}
        onBlur={onChangeSearch}
        onKeyPress={onKeyPress}
        aria-label={ariaLabel}
        placeholder={placeholder}
        size="sm"
        list="datalistKennziffern"
      >
      </Form.Control>
      <datalist id="datalistKennziffern">
        <option key={"user" + value} value={value}>Benutzereingabe: {value}</option>
        {options}
      </datalist>
    </div>
    {error
      ? <Alert variant="danger" className="p-1 fs-6">{error}</Alert>
      : null
    }
  </div>;
};
export default InputKennziffer;
